import React from "react";
import IcBanhoTosa from "../img/Ic_BanhoTosa.svg";
import IcClinica from "../img/Ic_Clinica.svg";
import IcConsulta from "../img/Ic_Consulta.svg";
import IcInternacao from "../img/Ic_Internacao.svg";
import IcTaxiPet from "../img/Ic_TaxiPet.svg";
import IcVacinacao from "../img/Ic_Vacinacao.svg";
import styles from "../styles/servicos.module.css";

interface ServicoProps {
  id: string;
  imgSrc: string;
  altText: string;
  title: string;
  description: string;
}

const Servicos: React.FC = () => {
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.servicoTitulo}>
        <h1>Serviços</h1>
        <p>
          Entenda como podemos <strong>ajudar o seu bichinho,</strong> as
          possibilidades são várias. Veja a seguir:
        </p>
      </div>

      <Servico
        id={styles.consultas}
        imgSrc={IcConsulta}
        altText="Consultas"
        title="Consultas"
        description="Sempre é hora de um bom check-up, por isso, agende a consulta em domicílio ou na clínica para garantir qualidade de vida ao seu melhor amigo."
      />

      <Servico
        id={styles.clinica}
        imgSrc={IcClinica}
        altText="Clínica geral e cirurgias"
        title="Clínica geral e cirurgias"
        description="Equipe multidisciplinar, experiente em rotina clínica, pronto atendimento e cirurgias que abrangem diversos níveis de complexidade."
      />

      <Servico
        id={styles.vacinacao}
        imgSrc={IcVacinacao}
        altText="Vacinação"
        title="Vacinação"
        description="Vacinas nacionais e importadas para manter a imunização do seu pet em dia, com aplicação agendada na clínica ou em domicílio."
      />

      <Servico
        id={styles.taxi}
        imgSrc={IcTaxiPet}
        altText="Castramóvel"
        title="Castramóvel "
        description="Contamos com um veículo totalmente equipado para percorrer o país com segurança, levando mutirões de castração aonde for necessário."
      />

      <Servico
        id={styles.internacao}
        imgSrc={IcInternacao}
        altText="Internamento"
        title="Internamento"
        description="Ambiente monitorado 24 horas, com baias para cães e gatos separadas em 3 salas diferentes. Sendo uma delas reservadas somente para gatos e outra para o isolamento de animais em tratamento."
      />

      <Servico
        id={styles.banho}
        imgSrc={IcBanhoTosa}
        altText="Banho e tosa"
        title="Banho e tosa"
        description="Profissionais carinhosos e treinados em um espaço confortável e equipado com modernos equipamentos para banho e tosa, afim de deixar o seu pet lindo, cheiroso e higienicamente saudável."
      />
    </div>
  );
};

const Servico: React.FC<ServicoProps> = ({
  id,
  imgSrc,
  altText,
  title,
  description,
}) => (
  <div className={styles.servico} id={id}>
    <img src={imgSrc} alt={altText} className={styles.iconeServico} />
    <div className={styles.descricaoServico}>
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  </div>
);

export default Servicos;
